import Joi from '@hapi/joi'

export const PlukingChecklistReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name is required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    toDate: Joi.string().invalid("").label("To date"),
    fromDate: Joi.string().invalid("").label("From date"),
    regNumber: Joi.string().label("Registration Number").messages({
        "any.invalid": `Registration number cannot have invalid characters`,
        "any.required": `Registration Number is required`
    }),
}